import React, { Component } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose,faTimesCircle, faCheckCircle  } from '@fortawesome/free-solid-svg-icons';
import logo from "../../assets/logo_espol_interno.svg";
import "../../css/admin/ModalUserForm.css";

export class ModalUserForm extends Component {
    render() {
        return (
            <div className="modalForm-background">
                <div className="modalForm-container">
                    <div className="modalForm-header1">
                        <img className='modalForm-logo' src={logo} alt="Logo espol" ></img>
                        <button className="modalForm-close" onClick={this.props.cerrarModal} >
                        <FontAwesomeIcon icon={faWindowClose}></FontAwesomeIcon>
                        </button>
                        <p className="modalForm-tituloHeader">{this.props.tituloHeader}</p>
                    </div>
                    <div className="modalForm-body">
                        
                        {this.props.children}
                        
                    </div>
                    <div className="modalForm-container-btn">

                        <button className="modalForm-botones" onClick={this.props.submit}>
                            <FontAwesomeIcon icon={faCheckCircle} className='modalForm-icono-bnt'></FontAwesomeIcon>
                            {this.props.txtBtnSubmit}
                        </button>

                        <button className="modalForm-botones" onClick={this.props.cerrarModal}>
                        <FontAwesomeIcon icon={faTimesCircle} className='modalForm-icono-bnt'></FontAwesomeIcon>
                        {this.props.txtBtnCancel}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default ModalUserForm
